export enum spPayoutEnum {
	PENDINGPAYOUT = 1,
	DONEPAYOUT = 2,
}

export enum spPaymentMethodEnum {
	BankAccount = 1,
	Fawry = 2,
	Instapay = 3,
}
export enum spPayoutListenum {
	PENDING = 1,
	PAYED = 2,
}
